import { oz } from '@weft/utils';
import { maskToken } from '../../../utils/mask-token';
import { INTEGRATION_PROVIDERS } from '../integration-providers-schema';
import { StripeIntegrationConfigurationSchema } from './stripe-integration-configuration';

export const StripeIntegrationSettingsSchema = oz.object({
  integrationProvider: oz.literal(INTEGRATION_PROVIDERS.stripe),
  integrationConfiguration: StripeIntegrationConfigurationSchema,
  bearerToken: oz.string().transform(maskToken),
}).openapi('StripeIntegrationSettings');

export type StripeIntegrationSettings = oz.infer<typeof StripeIntegrationSettingsSchema>;